import { useState, useEffect } from "react"
import "./App.css";
import { Provider } from "react-redux";
import { persistor, store } from "redux_dir/app/Store";
import { PersistGate } from "redux-persist/integration/react";
import Routes from "routes/app.routes";
import ErrorBoundary from "components/ErrorBoundary";
import { Toaster, toast } from "sonner";
import ServiceWorkerUpdater from "components/ServiceWorkerUpdater";
import NetworkStatus from "components/NetworkStatus";
import mixpanel from "mixpanel-browser";
import useTrackUtmVisit from "hooks/useTrackUtmVisit";

console.log = () => {};

function App() {

  const [isPWASupported, setIsPWASupported] = useState(true);

  // mixpanel.init("3b95480d685b5b59e6b406cfd8c28e88", {
  //   debug: true,
  //   track_pageview: true,
  //   persistence: "localStorage",
  // });

  useEffect(() => {
    // Check for basic PWA support
    const hasServiceWorker = 'serviceWorker' in navigator;
    const hasManifest = !!document.querySelector('link[rel="manifest"]');
    setIsPWASupported(hasServiceWorker && hasManifest);
  }, []);
  useEffect(() => {
    if (!isPWASupported) {
      handleServiceWorkerUnsupported()
    }
  }, [isPWASupported])


  const handleServiceWorkerUpdate = () => {
    console.log("Service worker update available");
  };

  const handleServiceWorkerUnsupported = () => {
    console.log("Service worker not supported");
    // Only show this toast once per session
    if (!sessionStorage.getItem('pwaNoticeShown')) {
      toast.info("Votre appareil ne prend pas en charge toutes les fonctionnalités de l'application. Certaines fonctionnalités peuvent être limitées.", { autoClose: 9000 });
      sessionStorage.setItem('pwaNoticeShown', 'true');
    }
  };


  useTrackUtmVisit();

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorBoundary>
            <Routes isPWASupported={isPWASupported} />
            <Toaster 
              position="bottom-center"
              richColors
              closeButton
              duration={3000}
              toastOptions={{
                style: {
                  borderRadius: '12px',
                },
              }}
            />
            <NetworkStatus />
            {isPWASupported && (
              <ServiceWorkerUpdater onUpdate={handleServiceWorkerUpdate} />
            )}
          </ErrorBoundary>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
